module.exports = __webpack_public_path__ + "img/87.missing_clothing.b3fbef27.svg";